export default __webpack_public_path__ + "static/media/apple.cce57d72.png";